import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class GuidedWorkflowsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getPageGuidedWorkflows(path) {
        const url = this.urlsService.getUrl(this.urlsService.GUIDED_WORKFLOWS.COLLECTION);
        return this.ajaxService.getDataObserveBody(url, { path });
    }
}
GuidedWorkflowsService.ɵfac = function GuidedWorkflowsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
GuidedWorkflowsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedWorkflowsService, factory: GuidedWorkflowsService.ɵfac, providedIn: 'root' });
